import { render } from "./CodeChallenge.vue?vue&type=template&id=ec0c7182"
import script from "./CodeChallenge.vue?vue&type=script&lang=js"
export * from "./CodeChallenge.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__